export default __webpack_public_path__ + "static/media/prestashop-negative.ea3c1c59.svg";